import Style1 from "./layout/style-1";
import Style2 from "./layout/style-2";
import Style3 from "./layout/style-3";

function RenderView(props) {
	const { style, data } = props;

	return (
		<>
			{style === '1' && <Style1 {...props} data={data} />}
			{style === '2' && <Style2 {...props} data={data} />}
			{style === '3' && <Style3 {...props} data={data} />}
		</>
	)
}

export default RenderView;